import React from "react";
import styles from "./$Dos.module.css";
import dark from "./$DosDark.module.css";
import { Button, Col, Row } from "antd";
const DOS = ({ theme }) => {
  return (
    <div className={theme ? styles.outer : dark.outer}>
      <Row className={styles.dos_container}>
        <Col md={12} className={theme ? styles.dos_right : dark.dos_right}>
          <h1>DOS</h1> <br />
          <p className={theme ? styles.dos_p : dark.dos_p}>
            Migrating your DOS Punk will allow you to start staking your new ERC721 DOS Punk to earn $DOS, the official 
            reward token of the DOS Punks 
            <br />
            <br />
          More DOS utility will be announced soon, but will include claims for custom drops from max in addition to utility on ArtifactX, a fresh independent marketplace for digital art
          </p>
          <div>
            <Button className={styles.dos_btn}>STAKE</Button>
          </div>
        </Col>

        <Col md={12} className={styles.dos_left}>
          <img className={styles.image} src="../images/currency 1.png" alt="" />
        </Col>
      </Row>
    </div>
  );
};

export default DOS;
